<template>
	<div class="p-6 container-medium m-auto">
		<img class="mb-10" alt="MGS logo" src="../assets/mgs.svg" />
		DASHBOARD
		<pre>{{$store.state.user.user.email}}</pre>
	</div>
</template>

<script>
/** @format */
import {authComputed} from './../store/helpers.js';

export default {
	name: 'Dashboard',
	methods: {},
	computed: {
		...authComputed
	},
	data() {
		return {}
	}
};
</script>
